// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-__LoadingSpinner-module___container"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LoadingSpinner.module.css
// module id = 1347
// module chunks = 0